module.exports = __webpack_public_path__ + "img/icon_gzxm@2x.5b195cf1.png";